// extracted by mini-css-extract-plugin
export default {"notFound":"ProductDetail_notFound__Cz2Yy"};